<template>
    <div id="tbEdit">
        <MyTitle theTitle="填写退保信息"/>
        <div class="fd-com-scroll" v-if="isShow">

            <template v-for="(item,index) in list">
                <info-title
                    :title-content="item.title"
                    :title-attention="item.zhuyi"
                    vertical-line="true"
                />
<!--                <Slogan :theTitle="item.title"/>-->

                <van-cell-group>
                    <template v-for="(item1,index1) in item.dataList">

                        <template v-if="!item1.type">
                            <van-field
                                v-model="formData[item1.key]"
                                :disabled="item1.disabled"
                                :required="item1.required"
                                :label="item1.label"
                                :placeholder="'请输入'+item1.label"
                            ></van-field>
                        </template>

                        <template v-else-if="item1.type==='dropdown'">
                            <van-field
                                readonly
                                clickable
                                right-icon="arrow"
                                :required="item1.required"
                                name="picker"
                                :label="item1.label"
                                :value="assist[item1.key+'_Text']"
                                :placeholder="'点击选择'+item1.label"
                                @click="assist['showPicker_'+item1.key] = true"
                            />
                            <van-popup v-model="assist['showPicker_'+item1.key]" position="bottom">
                                <van-picker
                                    show-toolbar
                                    :columns="ddListAll[item1.source]"
                                    :default-index="item1.initIndex"
                                    @confirm="(item2,index2)=>onConfirm(item2,index2,item1.key)"
                                    @cancel="assist['showPicker_'+item1.key] = false"
                                />
                            </van-popup>
                        </template>

                        <template v-else-if="item1.type==='textarea'">
                            <van-field
                                class="fd-textarea"
                                type="textarea"
                                rows="2"
                                show-word-limit
                                autosize
                                :required="item1.required"
                                v-model="formData[item1.key]"
                                :label="item1.label"
                                :maxlength="item1.maxlength"
                                :placeholder="'请输入'+item1.label"
                            />
                        </template>

                        <template v-else-if="item1.type==='date'">
                            <van-field
                                v-model="assist[item1.key+'_Text']"
                                readonly
                                clickable
                                right-icon="arrow"
                                :required="item1.required"
                                :disabled="item1.disabled"
                                name="picker"
                                :label="item1.label"
                                :placeholder="'点击选择'+item1.label"
                                @click="assist['showPicker_'+item1.key] = !item1.disabled"
                            />
                            <van-popup v-model="assist['showPicker_'+item1.key]" position="bottom">
                                <van-datetime-picker
                                    type="date"
                                    v-model="currentDate"
                                    :min-date="minDate"
                                    :max-date="maxDate"
                                    @confirm="(item2,index2)=>onConfirm(item2,index2,item1.key)"
                                    @cancel="assist['showPicker_'+item1.key] = item1.disabled"
                                />
                            </van-popup>
                        </template>


                    </template>
                </van-cell-group>

            </template>
            <UploadCL
                ref="child"
                v-if="id"
                :dbid="dbid"
                :tbid="id"
                :isDownloaded="isDownloaded"
                @changeDownloaded="change2"
            />
        </div>

            <div class="fd-com-btn-container">
                <van-button
                    type="info"
                    round
                    plain
                    :disabled="!isDownloaded"
                    @click="goBack()"
                >
                    取消
                </van-button>
                <van-button
                    type="info"
                    round
                    :disabled="!isDownloaded"
                    @click="submitForm()"
                >
                    提交
                </van-button>
            </div>

    </div>
</template>

<script>
import MyTitle from '../../../components/common/myTitle';
import Slogan from '../../../components/common/slogan';
import InfoTitle from '../../../components/common/InfoTitle';
import UploadCL from './uploadCL';

import validate from "@/utils/validator/validator";

import {extend,transformDdl,formatDate} from '../../../utils/common';
import {getCode,createTB,getId} from '../../../api/common';

// 引用 —— 前提数据
import {list2,formData2,arrList2} from './dataInit';
import {Rule_cDbh, Rule_cFglxdh,Rule_dtCreatetime,Rule_nTblx,Rule_cLxms} from "@/utils/validator/rules2";
import {dateFormat} from "@/utils/dateFormatter";

export default {
name: "tbEdit",
    data() {
        return {
            // 前提数据
            myRules:[],
            list: extend([],list2),
            formData:extend({},formData2),
            arrList: extend({},arrList2),
            id:'',
            dbid:'',
            nSqbqje:'',

            // 接口数据 isShow判断
            codeList_902002:[],

            // 子组件控制数据
            // isDownloadind:false,
            isDownloaded:true,

            currentDate: new Date(),
            minDate: new Date("1800-01-01"),
            maxDate: new Date(),

            assist:{
                nTblx_Text:'',
                showPicker_nTblx:false,

                dtCreatetime_Text:'',
                showPicker_dtCreatetime:false,
            },

            // 辅助数据
            pickerOptions:{
                disabledDate(time){
                    let _max = Date.now()
                    return time.getTime() > _max;
                }
            },

            // 组装数据
            ddListAll:{},
        }
    },
    components: {MyTitle,Slogan,InfoTitle,UploadCL},
    computed:{
        // 是否显示
        isShow(){
            if(this.codeList_902002.length>0){
                this.initData();
                return true;
            }else{
                return false;
            }
        }
    },

    methods: {
        goBack() {
            history.go(-1)
        },
        // 子组件控制2
        change2(params){
            this.isDownloaded=params;
        },
        //返回或离开
        goHistory(path) {
            if(this.$route.path.indexOf('tuiBao')>-1){
                this.$confirm('离开页面前，请确认您填写的信息已暂存！', '提示', {
                    confirmButtonText: '继续离开',
                    cancelButtonText: '返回暂存',
                    type: 'warning'
                }).then(()=>{
                    this.$router.push(path)
                })
            }else{
                this.$router.push(path)
            }
        },


        onConfirm(item,index,type) {
            console.log('--onConfirm 111',item,index,type);
            if(type==='dtCreatetime'){
                this.currentDate = new Date(this.currentDate.setHours(8));
                this.formData[type] = this.currentDate;
                this.assist[type+'_Text']=dateFormat(this.formData[type], "yyyy-MM-dd")
            }else{
                this.formData[type]=item.value;
                this.assist[type+'_Text'] = item.text;
            }
            this.assist['showPicker_'+type] = false;
        },


        validateFormData(){
            // 校验规则
            let descriptor;
            descriptor={
                cDbh:Rule_cDbh,
                cFglxdh:new Rule_cFglxdh(false),
                dtCreatetime:Rule_dtCreatetime,
                nTblx:Rule_nTblx,
                cLxms:new Rule_cLxms(true),
            };

            let validated = validate(descriptor, this.formData);
            return validated;
        },

        //组装提交数据
        params(){
            const {dbid,id}=this;
            const {nDbje,cDbh,cFglxdh,dtCreatetime,nTblx,cLxms}=this.formData;
            console.log('--nDbje',nDbje);
            return {
                cId:id,cDbId:dbid,
                nDbje:Number(nDbje),cDbh,cFglxdh,dtCreatetime:formatDate(dtCreatetime),nTblx,cLxms
            };
        },
        //提交
        submitForm() {
            console.log('--数据提交',this.formData,this.params());

            if(!this.$refs.child.check_submit()){
                return false;
            }

            const validated = this.validateFormData();
            validated.then((res) => {
                console.log('--res',res);
                createTB(this.params()).then((res)=>{
                    if (res.code !== 200) {
                        this.$notify(res.message);
                    }else{
                        this.$notify({
                            type: 'success',
                            message: '提交成功'
                        });
                        setTimeout(()=>{
                            this.goBack();
                        },2000)
                    }
                });
                // this.addSqrInfo().then(() => {
                //     this.$router.push("/guaranteeInfo");
                // });
            }).catch((err) => {
                console.log('请完整填写表单数据',err);
            });

        },
        //初始化数据
        initData(){
            let sourceList=[];
            let ddListAll={};
            this.list.map(i => {
                i.dataList.map(j => {
                    j.source && sourceList.push(j.source);
                });
            });
            sourceList.map(i=>{
                ddListAll[i]=this[i];
            });
            this.ddListAll=ddListAll;
        },
        //获取数据
        getData(){
            const tbInfo=JSON.parse(sessionStorage.getItem('tbInfo')||'{}');
            const {dbid,cBdh,nSqbqje}=tbInfo;
            this.dbid=dbid;
            this.formData.cDbh=cBdh;
            this.formData.nDbje=nSqbqje;
            console.log('--tbInfo',tbInfo,nSqbqje,this.formData.nDbje,this.formData);
            // 退保类型
            getCode({codetype: 902002}).then((res) => {this['codeList_902002'] = transformDdl(res.data);});
            // 生成退保id
            getId().then((res) => {this.id=res.data;});
        }
    },
    created() {
        console.log('--tbEdit 111',this.formData);
        this.getData();

        var type='dtCreatetime';
        this.currentDate = new Date(this.currentDate.setHours(8));
        this.formData[type] = this.currentDate;
        this.assist[type+'_Text']=dateFormat(this.formData[type], "yyyy-MM-dd")
    }
}
</script>

<style lang="less" scoped>
#tbEdit {
    width: 100%;
    height: 100%;
    overflow: hidden;

        .fd-textarea {
            height: auto;
        }
}
</style>
